









import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'DetailsLayout',
})
export default class DetailsLayout extends Vue {}
